import {Environment, MutationParameters, UploadableMap} from 'relay-runtime';

import Util from '../../forecast-app/shared/util/util';
import {RelayOnCompleted, RelayOnError} from './MutationTypes';

type MutationClass<TInput, TOutput extends MutationParameters> = {
	commit: (
		environment: Environment,
		input: TInput,
		onSuccess?: RelayOnCompleted<TOutput>,
		onError?: RelayOnError,
		uploadables?: UploadableMap | null
	) => void;
	mutationId?: string;
};

export const CommitMutation = <TInput, TOutput extends MutationParameters>(
	mutationClass: MutationClass<TInput, TOutput>,
	input: TInput,
	onSuccess?: RelayOnCompleted<TOutput>,
	retry = true,
	uploadables: UploadableMap | null = null,
	onError?: RelayOnError
): void => {
	Util.CommitMutation(mutationClass, input, onSuccess, retry, uploadables, onError);
};
